const mainSite = process.env.REACT_APP_CORE_URL

export const externalRoutes= {
  MAIN_WEBAPP: `${mainSite}`,
  DASHBOARD: `${mainSite}/dashboard`,
  SURVEY: (scheduleId='undefined', slug='undefined', professionalProfileCode='undefined') => `${mainSite}/nps/${scheduleId}?next=${slug}&professional_profile_code=${professionalProfileCode}`,
}
